import { AbExperiment, ABTestEnum } from './types';

const config: { [key in ABTestEnum]: AbExperiment } = {
  // This is an example and is not a real, active test
  // [ABTestEnum.EXAMPLE_AB_TEST]: {
  //   id: 'articles_example_ab',
  //   control: 'control',
  //   variant: 'variant',
  //   urls: [
  //     {
  //       path: '/article/example-page',
  //       redirectUrl: '/blog/example-page/',
  //     },
  //   ],
  // },
};

export default config;
